<mat-card>
  <app-card-header
    [title]="title"
    icono="notification_important"
    [draggable]="!!dialogRef"
    [botonCerrar]="!!dialogRef"
    (cerrar)="volver()"
  ></app-card-header>

  <mat-divider></mat-divider>

  @if (!loading) {
    @if (form) {
      <form
        id="form-crear-alerta-seguridad"
        [formGroup]="form"
        autocomplete="off"
        (ngSubmit)="onSubmit()"
      >
        <mat-card-content
          [class.cardContentDialog]="dialogRef"
          [class.cardContentFullscreen]="!dialogRef"
          class="card-content-crear"
        >
          <!-- Vecino -->
          <app-content-card title="Vecino" icon="person" color="purple">
            <section class="inputs-group" [formGroup]="vecinoForm">
              <mat-form-field style="width: 100%">
                <mat-label>Teléfono</mat-label>
                <input
                  matInput
                  type="tel"
                  formControlName="telefono"
                  placeholder="1161234567"
                  (keyup)="buscarVecino($any($event.target).value)"
                />
                <mat-icon matPrefix>phone</mat-icon>
                @if (buscandoVecino) {
                  <mat-progress-spinner
                    matSuffix
                    mode="indeterminate"
                    diameter="18"
                  ></mat-progress-spinner>
                } @else if (configVecino) {
                  <mat-icon matSuffix style="color: #4caf50">
                    check_circle
                  </mat-icon>
                }
                <mat-hint>
                  @if (configVecino) {
                    Vecino encontrado:
                    {{ configVecino.datosPersonales?.nombre }}
                  } @else {
                    Ingresá el número de teléfono sin el 0 ni el 15
                  }
                </mat-hint>
                @if (vecinoForm.get('telefono')?.hasError('pattern')) {
                  <mat-error>Formato de teléfono inválido</mat-error>
                }
              </mat-form-field>
            </section>

            <section class="inputs-group" [formGroup]="vecinoForm">
              <mat-form-field style="width: 100%">
                <mat-label>Nombre</mat-label>
                <input
                  matInput
                  formControlName="nombre"
                  placeholder="Nombre y apellido"
                />
                <mat-icon matPrefix>badge</mat-icon>
              </mat-form-field>

              <mat-form-field style="width: 100%">
                <mat-label>DNI</mat-label>
                <input matInput formControlName="dni" placeholder="10500100" />
                <mat-icon matPrefix>person_outline</mat-icon>
              </mat-form-field>
            </section>
          </app-content-card>

          <!-- Datos de Alerta -->
          <app-content-card
            title="Datos de Alerta"
            icon="warning"
            color="orange"
          >
            <section class="inputs-group">
              <ng-select
                style="width: 100%"
                formControlName="idBoton"
                placeholder="Tipo de Alerta"
                [items]="botones"
                bindLabel="nombre"
                bindValue="_id"
                appendTo="body"
                notFoundText="Sin resultados"
              ></ng-select>
            </section>

            <section class="inputs-group">
              <app-localidad-selector
                formControlName="idLocalidad"
                placeholder="Localidad"
                [clearable]="true"
              ></app-localidad-selector>
            </section>

            <section class="inputs-group">
              <div class="direccion-resumen">
                <div class="direccion-resumen-label">
                  <mat-icon>location_on</mat-icon>
                  Dirección seleccionada en mapa
                </div>
                <div class="direccion-resumen-value">
                  {{
                    form?.get('direccion')?.value ||
                      'Sin dirección seleccionada'
                  }}
                </div>
              </div>
            </section>

            <section class="inputs-group">
              <div class="mapa-embebido-wrapper">
                <app-mapa-ubicar
                  [raster]="'google'"
                  [form]="geojson"
                  [centrarA]="centrarA"
                  [enableAutocomplete]="true"
                  (direccion)="patchDireccion($event)"
                ></app-mapa-ubicar>
              </div>
            </section>

            <section class="inputs-group">
              <mat-form-field appearance="outline" style="width: 100%">
                <mat-label>Detalles de la dirección</mat-label>
                <textarea
                  matInput
                  formControlName="detallesDireccion"
                  placeholder="Piso, departamento, entrecalles, referencias..."
                  rows="2"
                ></textarea>
                <mat-icon matPrefix>info</mat-icon>
              </mat-form-field>
            </section>
          </app-content-card>

          <!-- Derivación -->
          <app-content-card
            title="Derivación (opcional)"
            icon="swap_horiz"
            color="blue"
          >
            <section class="inputs-group">
              <ng-select
                style="width: 100%"
                formControlName="tipoDelegacion"
                placeholder="Tipo de Derivación"
                [items]="tiposDelegacion"
                bindLabel="etiqueta"
                bindValue="valor"
                [clearable]="true"
                appendTo="body"
                notFoundText="Sin resultados"
              ></ng-select>
            </section>

            @if (tipoDelegacion && tipoDelegacion !== 'externa') {
              <section class="inputs-group">
                <ng-select
                  style="width: 100%"
                  formControlName="idCentroDerivado"
                  placeholder="Centro de Monitoreo"
                  [items]="centrosMonitoreo"
                  bindLabel="nombre"
                  bindValue="_id"
                  appendTo="body"
                  [notFoundText]="
                    centrosMonitoreo.length
                      ? 'Sin resultados'
                      : 'Sin centros cargados'
                  "
                ></ng-select>
              </section>
            }

            @if (tipoDelegacion === 'externa') {
              <section class="inputs-group">
                <mat-form-field style="width: 100%">
                  <mat-label>Entidad Externa</mat-label>
                  <input
                    matInput
                    formControlName="entidadExterna"
                    placeholder="Ej: Policía Local, Bomberos"
                    [matAutocomplete]="autoEntidades"
                  />
                  <mat-icon matPrefix>phone_forwarded</mat-icon>
                  <mat-autocomplete
                    #autoEntidades="matAutocomplete"
                    [displayWith]="displayFn"
                  >
                    @for (e of entidadesExternasFiltradas; track e) {
                      <mat-option [value]="e">{{ e }}</mat-option>
                    }
                  </mat-autocomplete>
                  <mat-hint>
                    Seleccioná del histórico ({{ entidadesExternas.length }}
                    entidades) o escribí una nueva
                  </mat-hint>
                </mat-form-field>
              </section>
            }
          </app-content-card>
        </mat-card-content>

        <mat-divider></mat-divider>

        <mat-card-actions class="actions-create">
          <app-button
            matType="mat-fab extended"
            color="neutral"
            (click)="volver()"
            text="Cancelar"
            icon="close"
          ></app-button>
          <app-button
            matType="mat-fab extended"
            [disabled]="!form.valid || loading"
            color="primary"
            text="Guardar"
            icon="save"
            type="submit"
          ></app-button>
        </mat-card-actions>
      </form>
    }
  } @else {
    <section class="inputs-group">
      <app-loading text="Cargando formulario..." [diameter]="60"></app-loading>
    </section>
  }
</mat-card>
